<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="card">
            <div class="card-body">
                <div class="card-title">
                    <div class="row">
                        <!--Messaggio con rapportino + utente + stato-->
                        <div class="col-12 d-flex align-items-center p-1">
                            <h3 class="m-0" [ngClass.md]="'mr-1'">{{"WORKDAY_REPORT_OF" | translate}} {{ reportMonthAndYear}}</h3>
                            <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-secondary ml-1"
                                  *ngIf="!previousReports">{{"STATUS.NOT_SAVED" | translate}}</span>
                            <div [ngClass.xl]="'ml-1'" *ngIf="previousReports">
                            <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-success"
                                  *ngIf="previousReports && previousReports.status===2">{{"APPROVED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-info mr-1"
                                      *ngIf="previousReports && previousReports.status===0">{{"STATUS.SAVED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-secondary"
                                      *ngIf="previousReports && previousReports.status===0">{{"NOT_SENDED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-danger"
                                      *ngIf="previousReports && previousReports.status===3">{{"REJECTED" | translate}}</span>
                                <span [ngClass.sm]="'mt-1'" [ngClass.md]="'mt-1'" class="font-small-3 badge badge-warning"
                                      *ngIf="previousReports && previousReports.status===1">{{"PENDING" | translate}}</span>
                            </div>
                        </div>
                        <!--Nota rifiuto-->
                        <div class="col-12">
                            <div *ngIf="previousReports && previousReports.status_note && previousReports.status_note.length > 0 && previousReports.status === 3">
                                <p class="font-small-3 mb-0 pb-0">{{"MOTIVATION" | translate}}:</p>
                                <p class="font-small-4">{{previousReports.status_note}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!_utilService.isMobile && !_utilService.isTablet">
                    <div class="col-xl-3 col-12">
                        <h4>{{"DAYS" | translate | titlecase}}</h4>
                    </div>
                    <div class="col-xl-2 col-12">
                        <h4>{{"WORKED_HOURS" | translate}}</h4>
                    </div>
                    <div class="col-xl-2 col-12">
                        <h4>{{"NOT_WORKED_HOURS" | translate}}</h4>
                    </div>
                    <div class="col-xl-5 col-12 d-flex justify-content-center">
                        <h4>{{"EXTRA_HOURS" | translate}}</h4>
                    </div>
                </div>
                <div class="row align-items-center border p-1" *ngFor="let day of daysOfTheMonth"
                     [ngClass]="isWorkDay(day) ? (_utilService.isHoliday(day) ? 'day-holiday' : 'day-work') : 'day-off'">
                    <!--Giorni-->
                    <div class="col-xl-3 col-12">
                        {{_utilService.formatDate(day, 'dddd DD') | titlecase}}
                    </div>
                    <!--Ore lavorata-->
                    <div class="col-xl-2 col-12 mt-1 mt-md-0">
                        <span *ngIf="_utilService.isMobile || _utilService.isTablet">{{"HOURS" | translate | titlecase}}</span>  {{newReport.days[day].working_hours}}h
                    </div>
                    <!--Ore non lavorate-->
                    <div class="col-xl-2 col-12 mt-1 mt-md-0">
                        <div class="badge badge-light-primary mb-05" *ngFor="let permission_hour of newReport.days[day].absences">
                            {{permission_hour.category === 'permesso' ? permission_hour.hours + 'h' : ""}}  {{permission_hour.name}}
                        </div>
                    </div>
                    <!--Ore extra-->
                    <div class="col-xl-5 col-12 mt-1 mt-md-0">
                        <div class="d-flex flex-md-nowrap flex-wrap align-items-center justify-content-md-center justify-content-end">
                            <!--bottone + -->
                            <button class="btn btn-sm" (click)="openEditExtraHoursDiv(day)"
                                    *ngIf="(!_utilService.isMobile && !_utilService.isTablet) && (_utilService.formatDate(day, 'D') >= contractStartDay) && (statusReport !== 1 && statusReport !== 2) && (!newReport.days[day].addExtraHours && !newReport.days[day].extra.hours && !newReport.days[day].type_name)">
                                <i
                                        data-feather="plus" class="text-success" size="16"></i></button>
                            <button class="btn btn-outline-secondary btn-sm" (click)="openEditExtraHoursDiv(day)"
                                    *ngIf="(_utilService.isMobile || _utilService.isTablet) && (_utilService.formatDate(day, 'D') >= contractStartDay) && (statusReport !== 1 && statusReport !== 2) && (!newReport.days[day].addExtraHours && !newReport.days[day].extra.hours && !newReport.days[day].type_name)">
                                {{"ADD_EXTRA_HOUR" | translate}}
                            </button>
                            <!--bottone edit -->
                            <button class="btn btn-sm" (click)="openEditExtraHoursDiv(day)"
                                    *ngIf="(statusReport !== 1 && statusReport !== 2) && (newReport.days[day].extra.hours && newReport.days[day].type_name && !newReport.days[day].addExtraHours)">
                                <i
                                        data-feather="edit-2" class="text-primary" size="16"></i></button>
                            <!--bage ore extra -->

                            <div class="badge badge-light-primary"
                                 *ngIf="newReport.days[day].extra.hours && newReport.days[day].type_name && !newReport.days[day].addExtraHours">
                                {{_utilService.isMobile || _utilService.isTablet ? ('EXTRA'| translate) +':' : null}} {{newReport.days[day].extra.hours + 'h'}}  {{newReport.days[day].type_name}}
                            </div>
                            <!--input ore extra -->
                            <input class="form-control w-25 mr-075" type="number" [maxlength]="2" min="0" max="12"
                                   *ngIf="newReport.days[day].addExtraHours"
                                   [(ngModel)]="newReport.days[day].extra.hours">
                            <!--select categorie extra -->
                            <ng-select *ngIf="newReport.days[day].addExtraHours" class="mr-1 w-50" bindValue="id" bindLabel="name"
                                       id="categoryAbsence" [(ngModel)]="newReport.days[day].extra.type_id" [placeholder]="'CATEGORY' | translate"
                                       [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true"
                                       [items]="categoriesAbsencesList">
                            </ng-select>
                            <!--bottone annulla -->
                            <button class="btn btn-sm mr-1 mt-1 mt-md-0" *ngIf="newReport.days[day].addExtraHours"
                                    (click)="cancelExtraHour(day)" [ngbTooltip]="'CANCEL' | translate">
                                <i data-feather="x" class="text-warning" size="16"></i>
                            </button>
                            <!--bottone cancella -->
                            <button class="btn btn-sm mr-1 mt-1 mt-md-0" *ngIf="newReport.days[day].addExtraHours"
                                    (click)="deleteExtraHour(day)" [ngbTooltip]="'DELETE' | translate">
                                <i data-feather="trash" class="text-danger" size="16"></i>
                            </button>
                            <!--bottone salva -->
                            <button class="btn btn-sm mt-1 mt-md-0" *ngIf="newReport.days[day].addExtraHours"
                                    [disabled]="newReport.days[day].extra.hours == 0 || !newReport.days[day].extra.type_id"
                                    [ngbTooltip]="'SAVE' | translate"
                                    (click)="saveExtraHourEdit(day)"><i data-feather="check" class="text-success" size="16"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-footer px-0">
                    <!--Conteggio ore totali -->
                    <div class="row mb-1">
                        <div class="col-xl-2 col-12">
                            <label for="totalWorkedHours">{{"WORKED_HOURS" | translate}}:</label>
                            <div id="totalWorkedHours">{{totalWorkedHours}}h</div>
                        </div>
                        <div class="col-xl-2 col-12">
                            <label for="totalNotWorkedHours">{{"NOT_WORKED_HOURS" | translate}}:</label>
                            <div id="totalNotWorkedHours">{{totalNotWorkedHours}}h</div>
                        </div>
                        <div class="col-xl-3 col-12 text-md-center">
                            <label for="totalExtraHours">{{"EXTRA_HOURS" | translate}}:</label>
                            <div id="totalExtraHours" class="mr-3">{{totalExtraHours}}h</div>
                        </div>
                    </div>
                    <div class="row">
                        <!--Tasti visualizzabili soltanto dall'utente-->
                        <div class="col-12">
                            <!--Bottoni salva aggiorna e invia report -->
                            <div class="d-flex justify-content-end">
                                <button class="btn btn-outline-primary mr-1" (click)="updateReport()"
                                        *ngIf="previousReports && previousReports.status === 3">{{"RESEND_REPORT" | translate}}</button>
                                <button class="btn btn-primary" *ngIf="(!previousReports || (previousReports.status !== 1 && previousReports.status !== 2 && previousReports.status !== 3))"
                                        (click)="sendReport()">{{"SEND_REPORT" | translate}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

